/** role="status" so a loading state is announced; respects reduced motion. */
export function Spinner({ size = 'medium' }: { readonly size?: 'small' | 'medium' }) {
  const px = size === 'small' ? 14 : 20
  return (
    <span role="status" aria-label="Loading" style={{ display: 'inline-flex' }}>
      <span
        className="ui-spinner"
        style={{
          width: px,
          height: px,
          borderRadius: '50%',
          border: '2px solid var(--border)',
          borderTopColor: 'var(--brand)',
          display: 'inline-block',
        }}
      />
    </span>
  )
}
